import axios from '@services/axios'
import UserStore from '@stores/UserStore'

interface ISubmit {
  childrenResource: number
  payAmount: number,
  payType: number,
  picUrl: string,
  productPrice: number,
  productSkuId: string,
  trainingItemId: string,
  trainingItemName: string
}
const PreFix = 'learn/app'

export const URL = {
  // 培训项目售卖信息及价格详情
  salesInformation: `${PreFix}/clientapi/trainingclass/cloudschool/payment/salesInformation.do`,

  // 报名信息
  userInfo: `${PreFix}/clientapi/user/cloudschool/signup/userInfo.do`,

  // 保存报名信息
  saveUserInfo: `${PreFix}/clientapi/user/cloudschool/signup/saveUserInfo.do`,

  // 培训项目生成订单
  submit: `${PreFix}/clientapi/trainingclass/cloudschool/payment/submit.do`,

  // 培训项目立即支付
  pay: `${PreFix}/clientapi/trainingclass/cloudschool/payment/pay.do`,

  // 查询订单状态接口
  // test1-hrmsv3-mlearning-admin.pingan.com.cn/hrmsv3_zn_payment/resourcePay/order/status.do?
  getPayStatus: '/hrmsv3_zn_payment/resourcePay/order/status',

  // 免费培训项目报名
  freeTrainingItemApply: `${PreFix}/clientapi/trainingclass/cloudschool/payment/freeTrainingItemApply.do`,

  // 修改sid
  updateSid: `${PreFix}/clientapi/user/cloudschool/signup/updateSid.do`,
}

export default {
  salesInformation: async (
    trainingItemId: string
  ): Promise<any> => {
    return await axios.get(URL.salesInformation, {
      params: {
        trainingItemId
      },
    })
  },

  userInfo: async (
    trainingItemId: string
  ): Promise<any> => {
    return await axios.get(URL.userInfo, {
      params: {
        trainingItemId
      },
    })
  },

  saveUserInfo: (
    empName: string,
    nationalId: string,
    trainingItemId: string,
    mobilePhone: number
  ): Promise<any> => {
    return axios.post(URL.saveUserInfo, {
      empName,
      nationalId,
      trainingItemId,
      mobilePhone
    }, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    });
  },

  submit: (params: ISubmit): Promise<any> => {
    return axios.post(URL.submit, {
      ...params
    }, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    });
  },

  getPayInfo: async (
    orderId: string
  ): Promise<any> => {
    return await axios.get(URL.pay, {
      params: {
        orderId,
        sourceType: 2 // 1: 云校，2: 土建
      },
    })
  },

  getPayStatus: (orderId: string): Promise<any> => {
    return axios.post(`${URL.getPayStatus}?orderId=${orderId}`, {
      orderId
    }, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    });
  },

  freeTrainingItemApply: async (
    trainingItemId: string
  ): Promise<any> => {
    return await axios.get(URL.freeTrainingItemApply, {
      params: {
        trainingItemId
      },
    })
  },

  updateSid: (
    trainingItemId: string,
    mobilePhone: number
  ): Promise<any> => {
    return axios.post(URL.updateSid, {
      trainingItemId,
      mobilePhone
    }, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    });
  },
}
